import React from "react";
import { Link } from "react-router-dom";
import styles from "./footer.module.css";
import kurrLogo from "../../ASSETS/LOGO/footerLogo.svg";
import SocialIconsComponent from "../SOCIAL_ICONS";
import { footerColumns } from "../../CONTENT/navigation";

const Footer = () => (
  <footer className={styles.footer}>
    <div className={styles.inner}>
      <div className={styles.brand}>
        <Link to="/" aria-label="KUR Research home">
          <img src={kurrLogo} className={styles.logo} alt="KUR Research" />
        </Link>
        <p className={styles.about}>
          KUR Research is an integrated clinical research site network,
          partnering with community-based practices to bring diverse patient
          populations to clinical trials.
        </p>
        <div className={styles.social}>
          <SocialIconsComponent />
        </div>
      </div>

      <nav className={styles.columns} aria-label="Footer">
        {footerColumns.map((col) => (
          <div key={col.title}>
            <h2 className={styles.colTitle}>{col.title}</h2>
            <ul className={styles.list}>
              {col.links.map((l) => (
                <li key={l.href}>
                  <Link to={l.href} className={styles.link}>
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
        <div>
          <h2 className={styles.colTitle}>Contact</h2>
          <ul className={styles.list}>
            <li>
              <a href="tel:+18663005380" className={styles.link}>
                (866) 300-5380
              </a>
            </li>
            <li>
              <a href="mailto:info@kurr.com" className={styles.link}>
                info@kurr.com
              </a>
            </li>
            <li className={styles.address}>
              2425 Cedar Springs Rd
              <br />
              Dallas, Texas 75201
            </li>
          </ul>
        </div>
      </nav>
    </div>

    <div className={styles.legal}>
      <p className={styles.compliance}>
        We are committed to maintaining the highest standards of ethics and
        compliance. For any compliance-related inquiries or concerns, please
        contact us at{" "}
        <a href="mailto:compliance@kurr.com" className={styles.link}>
          compliance@kurr.com
        </a>
        .
      </p>
      <p className={styles.copy}>
        © Copyright KUR International, LLC – {new Date().getFullYear()} ·{" "}
        <Link to="/privacy-policy" className={styles.link}>
          Privacy Policy
        </Link>{" "}
        ·{" "}
        <Link to="/terms" className={styles.link}>
          Terms &amp; Conditions
        </Link>
      </p>
    </div>
  </footer>
);

export default Footer;
